(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[626],{

/***/ 299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Map; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-dom/client.js
var client = __webpack_require__(745);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./node_modules/mapbox-gl/dist/mapbox-gl.js
var mapbox_gl = __webpack_require__(6158);
var mapbox_gl_default = /*#__PURE__*/__webpack_require__.n(mapbox_gl);
// EXTERNAL MODULE: ./hooks/useGeolocation.tsx
var useGeolocation = __webpack_require__(3671);
// EXTERNAL MODULE: ./lib/auth.tsx + 1 modules
var auth = __webpack_require__(6441);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(9851);
// EXTERNAL MODULE: ./styles/fonts.ts
var fonts = __webpack_require__(3800);
// EXTERNAL MODULE: ./styles/colors.ts
var colors = __webpack_require__(9750);
// EXTERNAL MODULE: ./components/taskIcons/ActionPlanIcon.tsx
var ActionPlanIcon = __webpack_require__(7242);
// EXTERNAL MODULE: ./components/taskIcons/MemoryMapIcon.tsx
var MemoryMapIcon = __webpack_require__(3513);
// EXTERNAL MODULE: ./components/taskIcons/ManifestoIcon.tsx
var ManifestoIcon = __webpack_require__(1010);
// EXTERNAL MODULE: ./components/taskIcons/SitSpotIcon.tsx
var SitSpotIcon = __webpack_require__(9991);
// EXTERNAL MODULE: ./components/taskIcons/MarineCitizenshipIcon.tsx
var MarineCitizenshipIcon = __webpack_require__(8726);
// EXTERNAL MODULE: ./components/taskIcons/MarineIdentityIcon.tsx
var MarineIdentityIcon = __webpack_require__(289);
// EXTERNAL MODULE: ./components/taskIcons/DeepConfidenceIcon.tsx
var DeepConfidenceIcon = __webpack_require__(1093);
// EXTERNAL MODULE: ./components/taskIcons/BlueJobIcon.tsx
var BlueJobIcon = __webpack_require__(6124);
;// CONCATENATED MODULE: ./components/BlueSpaceMapPopup.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  margin: 0;\n\n  h3 {\n    margin: 0;\n    padding: 0.5rem 1rem;\n    ",
        "\n    font-size: ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: 0.75rem;\n\n  > * {\n    margin: 0.25rem;\n    width: 120px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 1rem 1rem;\n  text-align: center;\n\n  a {\n    position: relative;\n    overflow: hidden;\n    display: inline-block;\n    min-width: 100px;\n    padding: 0.4rem 1rem;\n    border: 0;\n    border-radius: 5px;\n    text-align: center;\n    ",
        ";\n    font-size: ",
        ";\n    text-decoration: none;\n    background: ",
        ";\n    color: ",
        ";\n    cursor: pointer;\n    transition:\n      background .3s ease-out,\n      color .3s ease-out;\n\n    &:hover {\n      background: ",
        ";\n      color: ",
        ";\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &:focus-visible {\n      box-shadow: 0 0 0 2px ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












function BlueSpaceMapPopup(param) {
    var blueSpace = param.blueSpace, mySchoolId = param.mySchoolId, target = param.target;
    var hasSignedManifesto = !!blueSpace.school.signed_manifesto;
    var hasAddedMemoryMap = blueSpace.school.memory_maps.length > 0;
    var hasAddedSitSpot = blueSpace.school.sit_spots.length > 0;
    var hasSubmittedActionPlan = !!blueSpace.school.action_plan;
    var hasSubmittedMarineCitizenship = !!blueSpace.school.marine_citizenship;
    var hasSubmittedMarineIdentity = !!blueSpace.school.marine_identity;
    var hasSubmittedDeepConfidence = !!blueSpace.school.deep_confidence;
    var hasSubmittedBlueJob = !!blueSpace.school.blue_job;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBlueSpaceMarker, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: blueSpace.school.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTasks, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManifestoIcon/* default */.Z, {
                            complete: hasSignedManifesto
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MemoryMapIcon/* default */.Z, {
                            complete: hasAddedMemoryMap
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SitSpotIcon/* default */.Z, {
                            complete: hasAddedSitSpot
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionPlanIcon/* default */.Z, {
                            complete: hasSubmittedActionPlan
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarineCitizenshipIcon/* default */.Z, {
                            complete: hasSubmittedMarineCitizenship
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarineIdentityIcon/* default */.Z, {
                            complete: hasSubmittedMarineIdentity
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeepConfidenceIcon/* default */.Z, {
                            complete: hasSubmittedDeepConfidence
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlueJobIcon/* default */.Z, {
                            complete: hasSubmittedBlueJob
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: target,
                    href: mySchoolId === blueSpace.school.id ? "/dashboard" : "/dashboard/".concat(blueSpace.school.id),
                    children: "View"
                })
            })
        ]
    });
}
var StyledBlueSpaceMarker = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a34f468-0"
})(_templateObject(), fonts/* typo.diaryNotes */.f.diaryNotes, fonts/* typo.sizes.bumped */.f.sizes.bumped, colors/* default.navy */.Z.navy, colors/* default.white */.Z.white);
var StyledTasks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a34f468-1"
})(_templateObject1());
var StyledButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2a34f468-2"
})(_templateObject2(), fonts/* typo.satoshiBold */.f.satoshiBold, fonts/* typo.sizes.dropped */.f.sizes.dropped, colors/* default.yellow */.Z.yellow, colors/* default.navy */.Z.navy, colors/* default.navy */.Z.navy, colors/* default.yellow */.Z.yellow, colors/* default.navy */.Z.navy);
/* harmony default export */ var components_BlueSpaceMapPopup = (BlueSpaceMapPopup);

;// CONCATENATED MODULE: ./components/VideoMapPopup.tsx
function VideoMapPopup_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function VideoMapPopup_templateObject() {
    var data = VideoMapPopup_taggedTemplateLiteral([
        "\n  padding: 0;\n  margin: 0;\n\n  h3 {\n    margin: 0;\n    padding: 0.5rem 1rem;\n    ",
        "\n    font-size: ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    VideoMapPopup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoMapPopup_templateObject1() {
    var data = VideoMapPopup_taggedTemplateLiteral([
        "\n  iframe {\n    width: 100%;\n    aspect-ratio: 315 / 560;\n    height: auto;\n    border: none;\n    display:block;\n  }\n"
    ]);
    VideoMapPopup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




function VideoMapPopup(param) {
    var iframeTitle = param.iframeTitle, embed = param.embed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoMapPopup_StyledBlueSpaceMarker, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIframe, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                title: iframeTitle,
                width: "315",
                height: "560",
                src: embed,
                allowFullScreen: true
            })
        })
    });
}
var VideoMapPopup_StyledBlueSpaceMarker = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1ea4f4c-0"
})(VideoMapPopup_templateObject(), fonts/* typo.diaryNotes */.f.diaryNotes, fonts/* typo.sizes.bumped */.f.sizes.bumped, colors/* default.navy */.Z.navy, colors/* default.white */.Z.white);
var StyledIframe = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d1ea4f4c-1"
})(VideoMapPopup_templateObject1());
/* harmony default export */ var components_VideoMapPopup = (VideoMapPopup);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 9 modules
var polished_esm = __webpack_require__(6637);
;// CONCATENATED MODULE: ./components/icons/PlusIcon.tsx

function PlusIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.1815 4.21851C19.9413 2.80713 18.3969 1.69575 16.6646 0.968203C14.9324 0.240656 13.0575 -0.0840702 11.1815 0.0185126C9.32684 0.133208 7.52415 0.677053 5.9155 1.60719C4.30684 2.53733 2.93617 3.82835 1.91151 5.37851C0.942276 6.77392 0.324737 8.38295 0.111508 10.0685C-0.108017 11.7396 -0.00275621 13.4373 0.421508 15.0685C0.685735 16.2325 1.14198 17.3444 1.77151 18.3585C2.22457 19.0324 2.80972 19.6074 3.49151 20.0485C3.5584 20.0916 3.63932 20.1074 3.71751 20.0925C3.79569 20.0776 3.86516 20.0332 3.91151 19.9685C3.93414 19.9358 3.95003 19.8989 3.95826 19.86C3.96649 19.821 3.9669 19.7808 3.95945 19.7418C3.95201 19.7027 3.93686 19.6655 3.91489 19.6323C3.89293 19.5991 3.86458 19.5706 3.83151 19.5485C3.07856 19.0402 2.46351 18.353 2.04151 17.5485C1.62563 16.7095 1.31334 15.823 1.11151 14.9085C0.750376 13.3611 0.689273 11.7589 0.931508 10.1885C1.15833 8.64559 1.75534 7.18053 2.67151 5.91851C3.63663 4.51071 4.91613 3.34682 6.40877 2.51893C7.90141 1.69104 9.56623 1.22186 11.2715 1.14851C12.9609 1.07164 14.6461 1.37392 16.2034 2.0332C17.7608 2.69248 19.1508 3.69202 20.2715 4.95851C21.5871 6.45661 22.4575 8.29278 22.7845 10.2596C23.1114 12.2264 22.8817 14.2454 22.1215 16.0885C20.7015 19.4085 17.4715 22.0185 12.6915 22.5285C11.7985 22.6302 10.8981 22.6503 10.0015 22.5885C9.12318 22.524 8.25461 22.3631 7.41151 22.1085C7.36883 22.0947 7.32385 22.0895 7.27914 22.0931C7.23444 22.0967 7.19087 22.109 7.15094 22.1295C7.0703 22.1707 7.00936 22.2423 6.98151 22.3285C6.95366 22.4147 6.96119 22.5084 7.00245 22.5891C7.04371 22.6697 7.11531 22.7307 7.20151 22.7585C8.09015 23.0504 9.00961 23.2383 9.94151 23.3185C10.8698 23.3984 11.8032 23.3984 12.7315 23.3185C17.9015 22.8485 21.4115 20.0585 22.9915 16.4985C23.8662 14.4867 24.1603 12.2703 23.8404 10.1C23.5205 7.92974 22.5995 5.89236 21.1815 4.21851Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.00147 12.8284C9.71147 12.8284 10.5515 12.7584 11.4415 12.6984L11.5515 15.3784C11.5515 15.5684 11.7115 17.4484 11.7715 18.0484C11.7715 18.1184 11.7715 18.1984 11.7715 18.2684C11.7715 19.1584 11.9315 19.5884 12.1015 19.5684C12.7915 19.9784 12.4015 17.0884 12.4815 15.3784C12.4815 14.6684 12.5515 13.9584 12.5615 13.2484V12.6184C13.4715 12.5384 14.4015 12.4484 15.3015 12.3884C16.1941 12.3401 17.0888 12.3401 17.9815 12.3884C18.0261 12.3925 18.0712 12.3878 18.114 12.3744C18.1569 12.361 18.1966 12.3393 18.231 12.3105C18.2654 12.2816 18.2938 12.2463 18.3144 12.2065C18.3351 12.1667 18.3477 12.1231 18.3515 12.0784C18.357 12.0335 18.3533 11.9879 18.3404 11.9445C18.3276 11.901 18.306 11.8607 18.2769 11.826C18.2478 11.7913 18.2119 11.763 18.1714 11.7427C18.1309 11.7225 18.0867 11.7108 18.0415 11.7084C16.5159 11.5187 14.9779 11.4485 13.4415 11.4984H12.5315C12.5315 11.3784 12.5315 11.2584 12.5315 11.1284C12.4647 10.1763 12.3479 9.22828 12.1815 8.28841C12.0701 7.53367 11.8791 6.79286 11.6115 6.07841C11.4315 5.69841 11.4715 5.49841 11.2515 5.50841C11.2117 5.50702 11.1721 5.51382 11.135 5.5284C11.098 5.54299 11.0644 5.56503 11.0362 5.59317C11.0081 5.62132 10.986 5.65495 10.9715 5.69198C10.9569 5.72901 10.9501 5.76864 10.9515 5.80841C10.9515 6.25841 10.9515 5.60841 11.1615 7.06841C11.2515 7.66841 11.2715 8.28841 11.2815 8.39841L11.4015 11.5684H11.1815C10.3515 11.6284 9.58147 11.7384 8.92147 11.8084C8.49147 11.8684 8.04147 11.9084 7.59147 11.9484L5.59147 12.0584C5.54943 12.0557 5.50726 12.0613 5.4674 12.0749C5.42753 12.0886 5.39075 12.1099 5.35916 12.1378C5.32757 12.1657 5.3018 12.1995 5.28332 12.2374C5.26484 12.2752 5.25401 12.3164 5.25147 12.3584C5.24431 12.4318 5.26353 12.5053 5.30568 12.5658C5.34783 12.6263 5.41015 12.6697 5.48147 12.6884C5.61753 12.7066 5.7554 12.7066 5.89147 12.6884L7.65147 12.7884C8.09147 12.8384 8.56147 12.8484 9.00147 12.8284Z",
                fill: "#000"
            })
        ]
    });
}
/* harmony default export */ var icons_PlusIcon = (PlusIcon);

// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(7966);
;// CONCATENATED MODULE: ./components/AddYourBlueSpaceButton.tsx
function AddYourBlueSpaceButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AddYourBlueSpaceButton_templateObject() {
    var data = AddYourBlueSpaceButton_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 3px;\n\n  button,\n  a {\n    display: flex;\n    align-items: center;\n    height: 2rem;\n    padding: 0 0.5rem;\n    white-space: nowrap;\n    pointer-events: auto;\n    border: 0;\n    border-radius: 5px;\n    box-shadow: 0 1px 3px 0 ",
        ";\n    background: ",
        ";\n    color: ",
        ";\n    ",
        "\n    font-size: ",
        ";\n    text-decoration: none;\n    cursor: pointer;\n    opacity: ",
        ";\n    transition:\n      background .3s ease-out,\n      color .3s ease-out,\n      opacity .3s ease-out;\n\n    svg {\n      margin-left: 0.5rem;\n      opacity: 0.3;\n      \n      path {\n        transition: fill .3s ease-out;\n      }\n    }\n\n    &:hover {\n      background: ",
        ";\n      color: ",
        ";\n\n      svg {\n        margin-left: 0.5rem;\n        opacity: 1;\n\n        path {\n          fill: ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    AddYourBlueSpaceButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function AddYourBlueSpaceButton() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var me = (0,auth/* useAuth */.aC)();
    var ref2 = (0,react.useState)(true), isVisible = ref2[0], setVisible = ref2[1];
    var domRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var domElement = domRef.current;
        var observer = new IntersectionObserver(function(entries) {
            setVisible(entries[0].isIntersecting);
        }, {
            rootMargin: "-200px 0px 0px 0px"
        });
        if (domElement) {
            observer.observe(domElement);
            return function() {
                return observer.unobserve(domElement);
            };
        }
    }, []);
    if (me === null || me === void 0 ? void 0 : (ref = me.user) === null || ref === void 0 ? void 0 : ref.schoolId) {
        return null;
    }
    var href = me.isAuthenticated && ((ref1 = me.user) === null || ref1 === void 0 ? void 0 : ref1.role) === "SCHOOL" ? "/add-your-blue-space" : "".concat(router.asPath, "?register");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddYourBlueSpaceButton_StyledButton, {
        ref: domRef,
        $isVisible: isVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            href: href,
            children: [
                "Add your blue space to the map",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_PlusIcon, {})
            ]
        })
    });
}
var AddYourBlueSpaceButton_StyledButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-de499a73-0"
})(AddYourBlueSpaceButton_templateObject(), function(p) {
    return (0,polished_esm/* rgba */.m4)(p.theme.colors.navy, 0.5);
}, function(p) {
    return p.theme.colors.yellow;
}, function(p) {
    return p.theme.colors.navy;
}, function(p) {
    return p.theme.typo.satoshiBold;
}, function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.$isVisible ? 1 : 0;
}, function(p) {
    return p.theme.colors.navy;
}, function(p) {
    return p.theme.colors.yellow;
}, function(p) {
    return p.theme.colors.yellow;
});
/* harmony default export */ var components_AddYourBlueSpaceButton = (AddYourBlueSpaceButton);

// EXTERNAL MODULE: ./node_modules/mapbox-gl/dist/mapbox-gl.css
var dist_mapbox_gl = __webpack_require__(7329);
;// CONCATENATED MODULE: ./components/Map.tsx
function Map_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Map_templateObject() {
    var data = Map_taggedTemplateLiteral([
        "\n  position: relative;\n  height: ",
        ";\n  background: #000000;\n  overflow: hidden; \n"
    ]);
    Map_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Map_templateObject1() {
    var data = Map_taggedTemplateLiteral([
        "\n  div {\n    text-align: center;\n    display: none;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-bottom: 1em;\n  }\n\n  input {\n    display: inline-block;\n    margin: .5rem 0.25rem 0.5rem 1.75rem;\n  }\n\n  select {\n    margin-left: 1.5rem;\n    padding-left: 0.25rem;\n  }\n\n  label {\n    cursor:pointer\n  }\n"
    ]);
    Map_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Map_templateObject2() {
    var data = Map_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    Map_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Map_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  top: 4rem;\n  right: 0;\n  pointer-events: none;\n\n  @media ( max-width: 600px ) {\n    top: auto;\n    right: auto;\n    bottom: 4rem;\n    left: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












function Map(param) {
    var blueSpaces = param.blueSpaces, _center = param.center, center = _center === void 0 ? null : _center, _zoom = param.zoom, zoom = _zoom === void 0 ? null : _zoom, _withButton = param.withButton, withButton = _withButton === void 0 ? true : _withButton, _height = param.height, height = _height === void 0 ? "80vh" : _height, _target = param.target, target = _target === void 0 ? "_self" : _target, _interfaceColor = param.interfaceColor, interfaceColor = _interfaceColor === void 0 ? "#0D4466" : _interfaceColor;
    var ref, ref1, ref2;
    var missionState = (0,react.useRef)("all");
    var mapNodeRef = (0,react.useRef)();
    var mapboxMapRef = (0,react.useRef)(null);
    var mapboxBlueSpaceMarkers = (0,react.useRef)([]);
    var mapboxVideoMarkers = (0,react.useRef)([]);
    var me = (0,auth/* useAuth */.aC)();
    var mySchoolId = me === null || me === void 0 ? void 0 : (ref = me.user) === null || ref === void 0 ? void 0 : ref.schoolId;
    var browserLocation = (0,useGeolocation/* default */.Z)();
    var goodBlueHumans = [
        {
            title: "Stephen Kelly - Marine Conservation Society",
            mission: "1",
            lat: 50.797010,
            lng: -0.431523,
            embed: "https://youtube.com/embed/FMp_C7VeXAI?feature=share"
        },
        {
            title: "Marina Grissin - Common Seas",
            mission: "1",
            lat: -7.604554,
            lng: 112.108696,
            embed: "https://youtube.com/embed/mEqT00GkSRY?feature=share"
        },
        {
            title: "Nayantara Jain - Reef Watch India",
            mission: "2",
            lat: 11.867398,
            lng: 92.684017,
            embed: "https://youtube.com/embed/vg5nBayfzT4?feature=share"
        },
        {
            title: "Rosalin Kuiper - Ocean Race",
            mission: "2",
            lat: 54.353335,
            lng: 10.141404,
            embed: "https://youtube.com/embed/fbM8WLM9KYQ?feature=share"
        },
        {
            title: "Annukka Pekkarinen - Snowchange Cooperative",
            mission: "2",
            lat: 62.688133,
            lng: 29.998951,
            embed: "https://youtube.com/embed/lAE38mydyAE?feature=share"
        },
        {
            title: "John Luft - Great Salt Lake Ecosystem Program",
            mission: "2",
            lat: 41.122264,
            lng: -112.494319,
            embed: "https://youtube.com/embed/qG0YyUnm_m4?feature=share"
        },
        {
            title: "Chris Kastern - Abalobi",
            mission: "3",
            lat: -34.103596,
            lng: 18.484591,
            embed: "https://youtube.com/embed/lEqvcuUlSUU?feature=share"
        },
        {
            title: "Alan James - Stoney Creek Environmental Committee",
            mission: "3",
            lat: 49.256748,
            lng: -122.903859,
            embed: "https://youtube.com/embed/pGe4mS_2LOk?feature=share"
        },
        {
            title: "Pam Haigh - Ripple Africa",
            mission: "3",
            lat: -11.737794,
            lng: 34.542904,
            embed: "https://youtube.com/embed/5WrpXs0L5MY?feature=share"
        },
        {
            title: "Konstantina Kostoula - Common Seas",
            mission: "4",
            lat: 37.086217,
            lng: 25.134501,
            embed: "https://youtube.com/embed/lBBgdQZ-Yog?feature=share"
        },
        {
            title: "Heather Bell - The Rivers Trust",
            mission: "4",
            lat: 50.544197,
            lng: -4.260579,
            embed: "https://youtube.com/embed/fYp_-d9MSzY?feature=share"
        },
        {
            title: "Myo Htet Aung -  Worldview International Foundation",
            mission: "5",
            lat: 17.076019,
            lng: 94.465743,
            embed: "https://youtube.com/embed/Qftg0SfWpH0?feature=share"
        },
        {
            title: "Georgia Wallis",
            mission: "5",
            lat: 50.366404,
            lng: -4.131191,
            embed: "https://youtube.com/embed/TfrLb_28sgg?feature=share"
        },
        {
            title: "Stacey Alvarez de la Campa - Common Seas",
            mission: "6",
            lat: 13.134406,
            lng: -59.637796,
            embed: "https://youtube.com/embed/J3Z2iAZEpaI?feature=share"
        },
        {
            title: "Mark Ssemakula, Kavango Zambezi TFCA",
            mission: "6",
            lat: -17.7995,
            lng: 25.1703,
            embed: "https://www.youtube.com/embed/rVUqLat293s"
        },
        {
            title: "Caroline H\xf6schle & Julika Vo\xdf - Space Whale",
            mission: "7",
            lat: 54.489924,
            lng: 9.037574,
            embed: "https://youtube.com/embed/ZfxB1TmClzo?feature=share"
        },
        {
            title: "Merijn Tinga - Plastic Soup Surfer",
            mission: "7",
            lat: 43.693459,
            lng: 7.277705,
            embed: "https://youtube.com/embed/0tDdHR7tLV4?feature=share"
        },
        {
            title: "Wim Pyl - Mangata Adventure",
            mission: "7",
            lat: 50.770495,
            lng: 5.456022,
            embed: "https://youtube.com/embed/U2F4Ar1kZsk?feature=share"
        },
        {
            title: "Dinarte Vieira - MARE Madeira",
            mission: "8",
            lat: 32.630519,
            lng: -16.917468,
            embed: "https://youtube.com/embed/surfUC9CNnw?feature=share"
        },
        {
            title: "Troy Tuckey - Nepal Water Initiative",
            mission: "8",
            lat: 28.505426,
            lng: 83.658447,
            embed: "https://youtube.com/embed/my1YTak-tpg?feature=share"
        },
        {
            title: "Brigid Meyers - Earth Echo",
            mission: "8",
            lat: 42.788334,
            lng: -73.697924,
            embed: "https://youtube.com/embed/iMuUkFn-e8k?feature=share"
        },
        {
            title: "Lea d\u2019Auriol - Oceanic Global",
            mission: "9",
            lat: 40.701659,
            lng: -74.020941,
            embed: "https://youtube.com/embed/F9wwhzWcH_I?feature=share"
        },
        {
            title: "Lorna Doogan - Mountains to Sea",
            mission: "9",
            lat: -36.779541,
            lng: 174.769523,
            embed: "https://youtube.com/embed/-DVlYtSollk?feature=share"
        },
        {
            title: "Meg Avon - We are Avon",
            mission: "10",
            lat: 51.440237,
            lng: -2.527125,
            embed: "https://youtube.com/embed/j7g2fSh5TyI?feature=share"
        },
        {
            title: "Ryann Jibson - Earth Echo",
            mission: "10",
            lat: 45.697954,
            lng: -83.897011,
            embed: "https://youtube.com/embed/55aEKKBqH0k?feature=share"
        },
        {
            title: "Luke Lerotholi - Youth4MPAS",
            mission: "10",
            lat: -27.635338,
            lng: 32.591424,
            embed: "https://www.youtube.com/embed/JmXNo_fBBgk?feature=share"
        }, 
    ];
    var mapCoords = (0,react.useMemo)(function() {
        if (center) {
            return {
                center: center,
                zoom: zoom || 8
            };
        }
        if (browserLocation.done) {
            return browserLocation.error ? {
                center: [
                    -4,
                    55
                ],
                zoom: 5
            } : {
                center: [
                    browserLocation.lng,
                    browserLocation.lat
                ],
                zoom: zoom || 8
            };
        }
        return null;
    }, [
        browserLocation.done,
        browserLocation.error,
        browserLocation.lat,
        browserLocation.lng,
        center,
        zoom, 
    ]);
    var shouldShowButton = withButton && (me === null || me === void 0 ? void 0 : (ref1 = me.user) === null || ref1 === void 0 ? void 0 : ref1.role) !== "ADMIN" && !(me === null || me === void 0 ? void 0 : (ref2 = me.user) === null || ref2 === void 0 ? void 0 : ref2.schoolId);
    var updateMapboxMission = function(e) {
        missionState.current = e;
        mapboxVideoMarkers.current.forEach(function(mapboxMarker) {
            if (mapboxMarker.missionNumber === missionState.current || missionState.current === "all") {
                mapboxMarker.addTo(mapboxMapRef.current) // Show marker
                ;
            // mapboxMarker.getElement().style.opacity = '1';
            } else {
                mapboxMarker.remove() // Hide marker
                ;
            // mapboxMarker.getElement().style.opacity = '0';
            }
        });
    };
    var updateMapboxMap = function(e) {
        if (e === "showVideos") {
            mapboxBlueSpaceMarkers.current.forEach(function(mapboxMarker) {
                mapboxMarker.remove() // Hide marker
                ;
            });
            mapboxVideoMarkers.current.forEach(function(mapboxMarker) {
                // mapboxMarker.addTo( mapboxMapRef.current ) // Show marker
                if (mapboxMarker.missionNumber === missionState.current || missionState.current === "all") {
                    mapboxMarker.addTo(mapboxMapRef.current) // Show marker
                    ;
                // mapboxMarker.getElement().style.opacity = '1';
                } else {
                    mapboxMarker.remove() // Hide marker
                    ;
                // mapboxMarker.getElement().style.opacity = '0';
                }
            });
        }
        if (e === "showBlueSpaces") {
            mapboxVideoMarkers.current.forEach(function(mapboxMarker) {
                mapboxMarker.remove() // Hide marker
                ;
            });
            mapboxBlueSpaceMarkers.current.forEach(function(mapboxMarker) {
                mapboxMarker.addTo(mapboxMapRef.current) // Show marker
                ;
            });
        }
        if (e === "showAll") {
            mapboxVideoMarkers.current.forEach(function(mapboxMarker) {
                // mapboxMarker.addTo( mapboxMapRef.current ) // Show marker
                if (mapboxMarker.missionNumber === missionState.current || missionState.current === "all") {
                    mapboxMarker.addTo(mapboxMapRef.current) // Show marker
                    ;
                // mapboxMarker.getElement().style.opacity = '1';
                } else {
                    mapboxMarker.remove() // Hide marker
                    ;
                // mapboxMarker.getElement().style.opacity = '0';
                }
            });
            mapboxBlueSpaceMarkers.current.forEach(function(mapboxMarker) {
                mapboxMarker.addTo(mapboxMapRef.current);
            });
        }
    };
    (0,react.useEffect)(function() {
        if (window === undefined || !mapNodeRef.current || !mapCoords || mapboxMapRef.current) {
            return;
        }
        mapboxMapRef.current = new (mapbox_gl_default()).Map({
            container: mapNodeRef.current,
            accessToken: "pk.eyJ1IjoicHJvdGVjdGJsdWUiLCJhIjoiY205OW4wZTdyMDdzZzJscjRkZWZhMmpsYiJ9.SuBy6RY7OLcrTX-7b8ksBw",
            style: "mapbox://styles/mapbox/streets-v11",
            center: mapCoords.center,
            zoom: 2,
            projection: "mercator"
        });
        mapboxMapRef.current.on("style.load", function() {
            mapboxMapRef.current.getStyle().layers.forEach(function(layer) {
                // Hide road layers
                if (layer.id.includes("road") || layer.id.includes("bridge") || layer.id.includes("tunnel") || layer.id.includes("transit") || layer.id.includes("rail")) {
                    mapboxMapRef.current.setLayoutProperty(layer.id, "visibility", "none");
                }
            });
        });
        if (mapboxMapRef.current) {
            mapboxMapRef.current.addControl(new (mapbox_gl_default()).NavigationControl());
        }
    }, [
        mapCoords
    ]);
    (0,react.useEffect)(function() {
        if (mapCoords && blueSpaces.length && mapboxMapRef.current) {
            blueSpaces.forEach(function(blueSpace) {
                var container = document.createElement("div");
                var root = (0,client.createRoot)(container);
                root.render(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_BlueSpaceMapPopup, {
                    blueSpace: blueSpace,
                    mySchoolId: mySchoolId,
                    target: target
                }));
                var popup = new (mapbox_gl_default()).Popup({
                    anchor: "bottom",
                    closeButton: false
                }).setDOMContent(container).addTo(mapboxMapRef.current);
                popup.on("open", function() {
                    mapboxMapRef.current.flyTo({
                        center: [
                            blueSpace.lng,
                            blueSpace.lat
                        ]
                    });
                });
                mapboxBlueSpaceMarkers.current.push(new (mapbox_gl_default()).Marker().setLngLat([
                    blueSpace.lng,
                    blueSpace.lat
                ]).addTo(mapboxMapRef.current).setPopup(popup).togglePopup());
            });
            goodBlueHumans.forEach(function(goodBlueHuman) {
                var container = document.createElement("div");
                var root = (0,client.createRoot)(container);
                root.render(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_VideoMapPopup, {
                    iframeTitle: goodBlueHuman.title,
                    embed: goodBlueHuman.embed
                }));
                var popup = new (mapbox_gl_default()).Popup({
                    anchor: "bottom",
                    closeButton: false
                }).setDOMContent(container);
                popup.on("open", function() {
                    mapboxMapRef.current.flyTo({
                        center: [
                            goodBlueHuman.lng,
                            goodBlueHuman.lat
                        ],
                        offset: [
                            0,
                            200
                        ]
                    });
                });
                var mapboxVideoMarker = new (mapbox_gl_default()).Marker({
                    color: "#F9B233"
                }).setLngLat([
                    goodBlueHuman.lng,
                    goodBlueHuman.lat
                ]);
                mapboxVideoMarker.missionNumber = goodBlueHuman.mission;
                mapboxVideoMarkers.current.push(mapboxVideoMarker);
            });
        }
    }, [
        blueSpaces,
        mySchoolId,
        mapCoords
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMapUI, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            style: {
                                color: interfaceColor
                            },
                            htmlFor: "showAll",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    onChange: function(e) {
                                        return updateMapboxMap(e.target.value);
                                    },
                                    type: "radio",
                                    name: "markerRadio",
                                    id: "showAll",
                                    value: "showAll",
                                    defaultChecked: true
                                }),
                                "Show Everything"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            style: {
                                color: interfaceColor
                            },
                            htmlFor: "showBlueSpaces",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    onChange: function(e) {
                                        return updateMapboxMap(e.target.value);
                                    },
                                    type: "radio",
                                    name: "markerRadio",
                                    id: "showBlueSpaces",
                                    value: "showBlueSpaces"
                                }),
                                "Blue Spaces"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            style: {
                                color: interfaceColor
                            },
                            htmlFor: "showVideos",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    onChange: function(e) {
                                        return updateMapboxMap(e.target.value);
                                    },
                                    type: "radio",
                                    name: "markerRadio",
                                    id: "showVideos",
                                    value: "showVideos"
                                }),
                                "Good Blue Humans"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                            name: "selectedMission",
                            onChange: function(e) {
                                return updateMapboxMission(e.target.value);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "all",
                                    children: "All Challenges"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "1",
                                    children: "Challenge 1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "2",
                                    children: "Challenge 2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "3",
                                    children: "Challenge 3"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "4",
                                    children: "Challenge 4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "5",
                                    children: "Challenge 5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "6",
                                    children: "Challenge 6"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "7",
                                    children: "Challenge 7"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "8",
                                    children: "Challenge 8"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "9",
                                    children: "Challenge 9"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "10",
                                    children: "Challenge 10"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMap, {
                $height: height,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMapContainer, {
                        ref: mapNodeRef
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCTAButton, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
                            children: shouldShowButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AddYourBlueSpaceButton, {})
                        })
                    })
                ]
            })
        ]
    });
}
var StyledMap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4045a1c2-0"
})(Map_templateObject(), function(p) {
    return p.$height;
});
var StyledMapUI = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4045a1c2-1"
})(Map_templateObject1());
var StyledMapContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4045a1c2-2"
})(Map_templateObject2());
var StyledCTAButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4045a1c2-3"
})(_templateObject3());
/* harmony default export */ var components_Map = (Map);


/***/ }),

/***/ 7242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function ActionPlanIcon(param) {
    var complete = param.complete;
    // const { bg, fg1, fg2 } = getIconColors( complete )
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        width: 100,
        height: 100,
        sizes: "100vw",
        style: {
            width: "100%",
            aspectRatio: "1"
        },
        src: complete ? "/images/icons/action-plan-colour.png" : "/images/icons/action-plan-grey.png",
        alt: "Action plan icon"
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ActionPlanIcon);


/***/ }),

/***/ 6124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BlueJobIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function BlueJobIcon(param) {
    var complete = param.complete;
    // const { bg, fg1, fg2 } = getIconColors( complete )
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        width: 100,
        height: 100,
        sizes: "100vw",
        style: {
            width: "100%",
            aspectRatio: "1"
        },
        src: complete ? "/images/icons/blue-job-colour.png" : "/images/icons/blue-job-grey.png",
        alt: "Invent a Blue Job icon"
    });
};


/***/ }),

/***/ 1093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DeepConfidenceIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function DeepConfidenceIcon(param) {
    var complete = param.complete;
    // const { bg, fg1, fg2 } = getIconColors( complete )
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        width: 100,
        height: 100,
        sizes: "100vw",
        style: {
            width: "100%",
            aspectRatio: "1"
        },
        src: complete ? "/images/icons/deep-confidence-colour.png" : "/images/icons/deep-confidence-grey.png",
        alt: "Deep confidence icon"
    });
};


/***/ }),

/***/ 1010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function ManifestoIcon(param) {
    var complete = param.complete;
    // const { bg, fg1, fg2 } = getIconColors( complete )
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        width: 100,
        height: 100,
        sizes: "100vw",
        style: {
            width: "100%",
            aspectRatio: "1"
        },
        src: complete ? "/images/icons/manifesto-colour.png" : "/images/icons/manifesto-grey.png",
        alt: "Sign the manifesto icon"
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ManifestoIcon);


/***/ }),

/***/ 8726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MarineCitizenshipIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function MarineCitizenshipIcon(param) {
    var complete = param.complete;
    // const { bg, fg1, fg2 } = getIconColors( complete )
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        width: 100,
        height: 100,
        sizes: "100vw",
        style: {
            width: "100%",
            aspectRatio: "1"
        },
        src: complete ? "/images/icons/marine-citizenship-colour.png" : "/images/icons/marine-citizenship-grey.png",
        alt: "Marine Citizenship icon"
    });
};


/***/ }),

/***/ 289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MarineIdentityIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function MarineIdentityIcon(param) {
    var complete = param.complete;
    // const { bg, fg1, fg2 } = getIconColors( complete )
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        width: 100,
        height: 100,
        sizes: "100vw",
        style: {
            width: "100%",
            aspectRatio: "1"
        },
        src: complete ? "/images/icons/marine-identity-colour.png" : "/images/icons/marine-identity-grey.png",
        alt: "Marine identity icon"
    });
};


/***/ }),

/***/ 3513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MemoryMapIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function MemoryMapIcon(param) {
    var complete = param.complete;
    // const { bg, fg1, fg2 } = getIconColors( complete )
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        width: 100,
        height: 100,
        sizes: "100vw",
        style: {
            width: "100%",
            aspectRatio: "1"
        },
        src: complete ? "/images/icons/memory-map-colour.png" : "/images/icons/memory-map-grey.png",
        alt: "Memory map icon"
    });
};


/***/ }),

/***/ 9991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SitSpotIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


function SitSpotIcon(param) {
    var complete = param.complete;
    // const { bg, fg1, fg2 } = getIconColors( complete )
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        width: 100,
        height: 100,
        sizes: "100vw",
        style: {
            width: "100%",
            aspectRatio: "1"
        },
        src: complete ? "/images/icons/sit-spot-colour.png" : "/images/icons/sit-spot-grey.png",
        alt: "Sit spot icon"
    });
};


/***/ }),

/***/ 3671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

function useGeolocation() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), position = ref[0], setPosition = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), done = ref1[0], setDone = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), error = ref2[0], setError = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function(param) {
                var coords = param.coords;
                setPosition({
                    lat: coords.latitude,
                    lng: coords.longitude
                });
                setDone(true);
                setError(false);
            }, function(e) {
                setPosition(null);
                setDone(true);
                setError(e.message);
            });
        } else {
            setPosition(null);
            setDone(true);
            setError("Browser geolocation unsupported.");
        }
    }, []);
    return _objectSpread({}, position, {
        error: error,
        done: done
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (useGeolocation);


/***/ }),

/***/ 7329:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 319:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useMutation; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7582);
/* harmony import */ var rehackt__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3914);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4012);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20);
/* harmony import */ var _parser_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4692);
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(990);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6252);







/**
 *
 *
 * > Refer to the [Mutations](https://www.apollographql.com/docs/react/data/mutations/) section for a more in-depth overview of `useMutation`.
 *
 * @example
 * ```jsx
 * import { gql, useMutation } from '@apollo/client';
 *
 * const ADD_TODO = gql`
 *   mutation AddTodo($type: String!) {
 *     addTodo(type: $type) {
 *       id
 *       type
 *     }
 *   }
 * `;
 *
 * function AddTodo() {
 *   let input;
 *   const [addTodo, { data }] = useMutation(ADD_TODO);
 *
 *   return (
 *     <div>
 *       <form
 *         onSubmit={e => {
 *           e.preventDefault();
 *           addTodo({ variables: { type: input.value } });
 *           input.value = '';
 *         }}
 *       >
 *         <input
 *           ref={node => {
 *             input = node;
 *           }}
 *         />
 *         <button type="submit">Add Todo</button>
 *       </form>
 *     </div>
 *   );
 * }
 * ```
 * @since 3.0.0
 * @param mutation - A GraphQL mutation document parsed into an AST by `gql`.
 * @param options - Options to control how the mutation is executed.
 * @returns A tuple in the form of `[mutate, result]`
 */
function useMutation(mutation, options) {
    var client = (0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)(options === null || options === void 0 ? void 0 : options.client);
    (0,_parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .verifyDocumentType */ .Vp)(mutation, _parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .DocumentType.Mutation */ .n_.Mutation);
    var _a = rehackt__WEBPACK_IMPORTED_MODULE_0__.useState({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = rehackt__WEBPACK_IMPORTED_MODULE_0__.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    // TODO: Trying to assign these in a useEffect or useLayoutEffect breaks
    // higher-order components.
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = rehackt__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, options), { mutation: mutation });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading &&
            !baseOptions.ignoreResults &&
            ref.current.isMounted) {
            setResult((ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            }));
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeOptions */ .J)(baseOptions, executeOptions);
        return client
            .mutate(clientOptions)
            .then(function (response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ?
                new _errors_index_js__WEBPACK_IMPORTED_MODULE_6__/* .ApolloError */ .cA({ graphQLErrors: errors })
                : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) {
                onError(error, clientOptions);
            }
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_1)) {
                    setResult((ref.current.result = result_1));
                }
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(response.data, clientOptions);
            }
            return response;
        })
            .catch(function (error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_2)) {
                    setResult((ref.current.result = result_2));
                }
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = rehackt__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
        if (ref.current.isMounted) {
            var result_3 = { called: false, loading: false, client: client };
            Object.assign(ref.current, { mutationId: 0, result: result_3 });
            setResult(result_3);
        }
    }, []);
    rehackt__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map

/***/ })

}]);